(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["supscepter-header"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeHeader = (root) => {
      if (!root || root.dataset.supHeaderReady === 'true') return;
      root.dataset.supHeaderReady = 'true';
      const menu = root.querySelector('[data-sup-mobile-menu]');
      if (!menu) return;
      const summary = menu.querySelector('summary');
      const closeButton = menu.querySelector('[data-sup-menu-close]');
      const controller = new AbortController();
      const syncScroll = () => document.documentElement.classList.toggle('sup-menu-open', menu.open);
      menu.addEventListener('toggle', syncScroll, { signal: controller.signal });
      closeButton?.addEventListener('click', () => {
        menu.open = false;
        summary?.focus();
      }, { signal: controller.signal });
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && menu.open) {
          menu.open = false;
          summary?.focus();
        }
      }, { signal: controller.signal });
      root.supHeaderController = controller;
    };

    document.querySelectorAll('[data-sup-header]').forEach(initializeHeader);
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('[data-sup-header]').forEach(initializeHeader);
    });
    document.addEventListener('shopify:section:unload', (event) => {
      const root = event.target.querySelector('[data-sup-header]');
      root?.supHeaderController?.abort();
      document.documentElement.classList.remove('sup-menu-open');
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
